<template>
    <div class="login-page">
        <div class="linea header">
            <div>
                <img src="/images/logo_sig_color_transp.png">
            </div>
        </div>
        <img src="/images/placeholders/layout/login2_full_bg2.jpg" alt="Full Background" class="full-bg animation-pulseSlow">
        <div id="login-container">
            <h1 class="h2 text-light text-center push-top-bottom animation-pullDown">
                <strong>BIENVENIDO A GESTIÓN</strong>
            </h1>


            <div class="block animation-fadeInQuick">
                <form id="frmIniciarSesion form-login" class="form-horizontal validate" @submit.prevent="login">
                    <div class="form-group">
                        <label for="username" class="col-xs-12" style="color: white;">Usuario</label>
                        <div class="col-xs-12">
                            <input type="text" class="form-control username" v-model="username" name="username" id="username" placeholder="Usuario">
                        </div>
                        <span v-if="errors?errors.username:''" :class="['text-warning']">{{ errors.username[0] }}</span>
                    </div>
                    <div class="form-group">
                        <label for="password" class="col-xs-12" style="color: white;">Contraseña</label>
                        <div class="col-xs-12">
                            <input type="password" class="form-control" v-model="password" name="password" id="password" placeholder="Contraseña">
                        </div>
                        <span v-if="errors?errors.password:''" :class="['text-warning']">{{ errors.password[0] }}</span><br>
                        <span v-if="message" :class="['text-warning']">{{ message }}</span>
                    </div>
                    <div class="form-group form-actions">
                        <div class="col-xs-8">
                            <label class="csscheckbox csscheckbox-primary" style="color: white;">
                                <input type="checkbox" id="login-remember-me" name="login-remember-me"><span></span> Recordarme
                            </label>
                        </div>
                        <div class="col-xs-8" v-if="errors">
                            <label class="csscheckbox csscheckbox-primary" style="color: white;">
                                <input type="checkbox" id="login-remember-me" name="login-remember-me"><span></span> <strong>Usuario y/o password incorrectos</strong>
                            </label>
                        </div>
                        <div class="col-xs-4 text-right">
                            <button type="submit" class="btn btn-effect-ripple btn-sm btn-success">Ingresar</button>
                        </div>
                    </div>
                    <div class="form-group message">
                        <div class="col-xs-12 error"></div>
                    </div>
                </form>
            </div>
            <footer class="text-muted text-center animation-pullUp">
                <img src="/images/logo_fga_color_transp.png" style="margin-top: 50px;width: 130px;margin-bottom: 10px;"><br>
                <small style="color: white;"><span id="year-copy" style="color: white;"></span> &copy; <a style="color: white;" href="http://www.fga.com.co" target="_blank">FGA Fondo de Garantías</a></small>
            </footer>
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            username: null,
            password: null,
            remember_me: false,
            errors: null,
            message: null
        }
    },
    computed: {
        documento() {
            return this.$router.currentRoute.query.documento
        }
    },
    methods: {
        login() {
            this.$store.dispatch('user/login', {username: this.username, password: this.password, remember_me: this.remember_me})
            .then(() => this.$router.push(this.$route.query.redirect || '/'))
            .catch((error) => {
                this.errors = error.response.data.error
                this.message = error.response.data.message
            })
        }
    }
}
</script>

